export const deliveryDays = state => state.deliveryDays
export const isLoading = state => state.isLoading
export const packProperties = state => state.packProperties
export const filters = state => state.filters
export const promoFilters = state => state.promoFilters
export const unauthorizedFilters = (state) => state.unauthorizedFilters
export const appliedUnauthorizedFilters = (state, getters, rootState, rootGetters) => {
  if (rootGetters['client/isLoggedIn']) {
    return rootGetters['client/profile']?.lastFilterOptions || []
  } else {
    return state.appliedUnauthorizedFilters
  }
}
export const unauthorizedFilterIds = (state) => state.unauthorizedFilterIds
export const maxActiveFiltersCount = (state) => {
  return state.maxActiveFiltersCount
}
export const allFilterOptions = (state) => {
  const options = []
  state.filters.forEach((filterGroup) => {
    options.push(...filterGroup.options)
  })
  return options
}
export const setProposedFiltersVersion = (state) => state.setProposedFiltersVersion
export const isUpdateFiltersModalVisible = (state) => state.isUpdateFiltersModalVisible
